import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ja } from 'date-fns/locale';
import { CircularProgress, Box } from '@mui/material';

// import { AuthProvider, useAuth } from './contexts/AuthContext';
import { SupabaseAuthProvider as AuthProvider, useAuth } from './contexts/SupabaseAuthContext';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import LoginSuccess from './pages/LoginSuccess';
import Tenants from './pages/Tenants';
import TenantDetail from './pages/TenantDetail';
import TenantUsers from './pages/TenantUsers';
import TenantUserDetail from './pages/TenantUserDetail';
import SystemUsers from './pages/SystemUsers';
import SystemHealth from './pages/SystemHealth';
import SlackConfig from './pages/SlackConfig';
import TenantFeatures from './pages/TenantFeatures';
import TenantNew from './pages/TenantNew';
// import Login from './pages/Login';
import Login from './pages/UnifiedLogin';
import Profile from './pages/Profile';
import Monitoring from './pages/Monitoring';
import AuthCallback from './pages/AuthCallback';

const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
    background: {
      default: '#f5f5f5',
    },
  },
  typography: {
    fontFamily: 'Roboto, "Noto Sans JP", sans-serif',
  },
});

function AppRoutes() {
  const { currentUser, isSystemAdmin, loading } = useAuth();

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  const isAuthenticated = currentUser && isSystemAdmin();

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/login-success" element={<LoginSuccess />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <Layout />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        >
          <Route index element={<Dashboard />} />
          <Route path="tenants" element={<Tenants />} />
          <Route path="tenants/new" element={<TenantNew />} />
          <Route path="tenants/:id" element={<TenantDetail />} />
          <Route path="tenants/:tenantId/features" element={<TenantFeatures />} />
          <Route path="tenant-users" element={<TenantUsers />} />
          <Route path="tenant-users/:id" element={<TenantUserDetail />} />
          <Route path="system-users" element={<SystemUsers />} />
          <Route path="health" element={<SystemHealth />} />
          <Route path="slack" element={<SlackConfig />} />
          <Route path="profile" element={<Profile />} />
          <Route path="monitoring" element={<Monitoring />} />
        </Route>
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ja}>
        <AuthProvider>
          <AppRoutes />
        </AuthProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;